module.exports = __webpack_public_path__ + "static/media/fileImg.ed7b67eb.PNG";